import { ref, watch } from 'vue'

export function useCollapseState(storageKey: string) {

    const stored = sessionStorage.getItem(storageKey)
    const collapseMap = ref<Record<string, boolean>>(stored ? JSON.parse(stored) : {})

    function toggle(id: string): void {
        collapseMap.value[id] = !collapseMap.value[id]
    }

    function isCollapsed(id: string): boolean {
        return collapseMap.value[id]
    }

    watch(collapseMap, (val) => sessionStorage.setItem(storageKey, JSON.stringify(val)), { deep: true });

    return {
        isCollapsed,
        toggle,
    };
}